import xhr         from "_common/xhr";
import { configs } from "_config/index";

export const initiateDonationPayment = async ( { amount, sportsFanId, donorDetails } ) => {
	const response = await xhr.post ( {
		url  : `${ configs.USER_API_URL }marketplace/anonymous/paytmInitiateMoneyDonation`,
		data : {
			amount,
			creditCurrencyId : 2,
			currencyId       : 1,
			donorDetails     : JSON.stringify ( donorDetails ),
			sportsFanId
		}
	} );

	return response;
};

export const getDonationDetails = async function ( { moneyDonationId, moneyDonationKey } ) {
	const response = await xhr.post.bind ( this ) ( {
		url  : `${ configs.USER_API_URL }marketplace/anonymous/paytmVerifyMoneyDonation`,
		data : {
			moneyDonationId,
			moneyDonationKey
		}
	} );

	return response;
};
